"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = Header;
exports.ActionHeader = ActionHeader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _consts = require("./consts");

var _utils = require("./utils");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SORT_DIRECTION = {
  UP: 'sortup',
  DOWN: 'sortdown',
  DEFAULT: 'sortable'
};

function Header(_ref) {
  var _ref2;

  var children = _ref.children,
      width = _ref.width,
      alignment = _ref.alignment,
      sortable = _ref.sortable,
      defaultSortDirection = _ref.defaultSortDirection,
      onSortDirectionChange = _ref.onSortDirectionChange,
      currentIndex = _ref.currentIndex,
      sortingDirection = _ref.sortingDirection,
      sortSequence = _ref.sortSequence,
      props = _objectWithoutProperties(_ref, ["children", "width", "alignment", "sortable", "defaultSortDirection", "onSortDirectionChange", "currentIndex", "sortingDirection", "sortSequence"]);

  var sortDirection = sortingDirection || sortSequence[currentIndex % sortSequence.length] || false;
  var headerClasses = ['co-table__head-cell', (_ref2 = {}, _defineProperty(_ref2, "co-table__header--sortable", sortable), _defineProperty(_ref2, "co-table__header--".concat(sortDirection), sortable && sortDirection), _ref2), (0, _utils.widthClass)(width)];
  return _react.default.createElement(_styler.default, {
    classNames: headerClasses,
    modifiers: {
      alignment: alignment
    }
  }, function (styles) {
    return _react.default.createElement("th", _extends({
      onClick: onSortDirectionChange,
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
}

function ActionHeader(_ref3) {
  var children = _ref3.children,
      width = _ref3.width,
      props = _objectWithoutProperties(_ref3, ["children", "width"]);

  return _react.default.createElement("th", _extends({
    className: (0, _classnames.default)('co-table__head-cell', 'co-table__column--actions', (0, _utils.widthClass)(width))
  }, (0, _getNativeProps.default)(props)), children);
}

Header.ALIGNMENT = _consts.ALIGNMENTS;
Header.WIDTH = _consts.WIDTHS;
Header.SORT_DIRECTION = SORT_DIRECTION;
Header.displayName = 'Table.Header';
ActionHeader.displayName = 'Table.ActionHeader';
Header.defaultProps = {
  defaultSortDirection: SORT_DIRECTION.DEFAULT,
  sortSequence: Object.values(SORT_DIRECTION)
};
Header.propTypes = {
  children: _propTypes.any,

  /** {const} One of: @@Table.Data.ALIGNMENT.LEFT@@ @@Table.Data.ALIGNMENT.CENTER@@ @@Table.Data.ALIGNMENT.RIGHT@@ */
  alignment: _consts.oneOfAlignments,

  /** {const} One of: @@Table.Header.SORT_DIRECTION.UP@@, @@Table.Header.SORT_DIRECTION.DOWN@@, @@Table.Header.SORT_DIRECTION.DEFAULT@@. When used, it should be the first  direction on the `sortSequence` array. */
  defaultSortDirection: (0, _propTypes.oneOf)([SORT_DIRECTION.UP, SORT_DIRECTION.DOWN, SORT_DIRECTION.DEFAULT]),

  /** {bool} Required if @@onSortDirectionChange@@ is defined. */
  sortable: (0, _airbnbPropTypes.requiredBy)('onSortDirectionChange', _propTypes.bool),

  /** {const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5) */
  width: _consts.oneOfBreakpoints,

  /** {func} Required if @@sortable@@ is truthy */
  onSortDirectionChange: (0, _airbnbPropTypes.requiredBy)('sortable', _propTypes.func),

  /** {array} Array of const: @@Table.Header.SORT_DIRECTION.UP@@, @@Table.Header.SORT_DIRECTION.DOWN@@, @@Table.Header.SORT_DIRECTION.DEFAULT@@) */
  sortSequence: _propTypes.array
};
ActionHeader.propTypes = {
  children: _propTypes.any,

  /** {const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5) */
  width: _consts.oneOfBreakpoints
};
Header.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.Header",
  "props": {
    "defaultSortDirection": {
      "defaultValue": {
        "value": "'sortable'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'sortup'",
          "computed": false
        }, {
          "value": "'sortdown'",
          "computed": false
        }, {
          "value": "'sortable'",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@Table.Header.SORT_DIRECTION.UP@@, @@Table.Header.SORT_DIRECTION.DOWN@@, @@Table.Header.SORT_DIRECTION.DEFAULT@@. When used, it should be the first  direction on the `sortSequence` array."
    },
    "sortSequence": {
      "defaultValue": {
        "value": "Object.values(SORT_DIRECTION)",
        "computed": true
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "{array} Array of const: @@Table.Header.SORT_DIRECTION.UP@@, @@Table.Header.SORT_DIRECTION.DOWN@@, @@Table.Header.SORT_DIRECTION.DEFAULT@@)"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "alignment": {
      "type": {
        "name": "custom",
        "raw": "oneOfAlignments"
      },
      "required": false,
      "description": "{const} One of: @@Table.Data.ALIGNMENT.LEFT@@ @@Table.Data.ALIGNMENT.CENTER@@ @@Table.Data.ALIGNMENT.RIGHT@@"
    },
    "sortable": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('onSortDirectionChange', bool)"
      },
      "required": false,
      "description": "{bool} Required if @@onSortDirectionChange@@ is defined."
    },
    "width": {
      "type": {
        "name": "custom",
        "raw": "oneOfBreakpoints"
      },
      "required": false,
      "description": "{const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5)"
    },
    "onSortDirectionChange": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('sortable', func)"
      },
      "required": false,
      "description": "{func} Required if @@sortable@@ is truthy"
    }
  }
};
ActionHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.ActionHeader",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "custom",
        "raw": "oneOfBreakpoints"
      },
      "required": false,
      "description": "{const} One of: @@Table.Data.WIDTHS[X]@@ (X between 5 and 100, in increments of 5)"
    }
  }
};